import React, { createContext, useReducer } from "react";
import Reducer from "./reducer";

const initialState = {
  hiddeSpinner: true
};

const Store = ({ children }) => {
  const [state, dispatch] = useReducer(Reducer, initialState);
  return (
    <Context.Provider value={[state, dispatch]}>{children}</Context.Provider>
  );
};

export const NOMBRE_TABLA_LABELS = {
  T_TAXUE_PROVINCIAS: "Provincias"
};

export const COLUMN_LABELS = {
  COD_PROVINCIA: "Código Provincia",
  DESC_PROVINCIA: "Provincia",
  COD_PAIS: "Código País",
  DESC_AUTONOMIA: "Autonomía",
  UMBRAL: "Umbral"
};

export const Context = createContext(initialState);
export default Store;